/**
 * Web Speech API helper for German voice recognition.
 * Returns null if unsupported (some browsers like Firefox don't support it).
 */
export function createSpeechRecognition(lang = 'de-DE') {
  const SR = (typeof window !== 'undefined') && (window.SpeechRecognition || window.webkitSpeechRecognition);
  if (!SR) return null;
  const recognition = new SR();
  recognition.lang = lang;
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.maxAlternatives = 1;
  return recognition;
}

export function isSpeechRecognitionSupported() {
  if (typeof window === 'undefined') return false;
  return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || '';
      const idx = String(result).indexOf(',');
      resolve({ dataUrl: result, base64: idx >= 0 ? result.slice(idx + 1) : result });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
